import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ErrorDetails, ICardDetailResponseDTO } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class ValidateCardHoldCommand extends IRequestCommand<
  IValidateCardHoldResponse,
  ErrorDetails,
  IValidateCardHoldCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.POST;
  override _commandUrl = 'cards/passengers/{passengerUserId}/cardValidationWithHold/{carrierId}';
  public override setParameters(parameters: IValidateCardHoldCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
        '{passengerUserId}',
        parameters.passengerUserId.toString()
    );
    this._commandUrl = this._commandUrl.replace(
        '{carrierId}',
        parameters.carrierId.toString()
    );
    this._commandBody = parameters;
  }
}

export interface IValidateCardHoldCommandParameters extends ICommandParameters {
    passengerUserId: number,
    token: string,
    cardId?: number,
    appId?: number,
    cardNumber?: string;
    cvv?: string;
    expirationYear?: number;
    expirationMonth?:number;
    issuerId?: string;
    issuerName?: string;
    paymentTypeId?: string;
    paymentMethodId?: string;
    cardholderName?: string;
    cardholderIdentificationNumber?: string;
    cardholderIdentificationType?: string;
    carrierId?: string;
}

export interface IValidateCardHoldResponse extends ICardDetailResponseDTO {
}
